import { all } from 'redux-saga/effects';
import GlobalSaga from './global/saga';

export default function* rootSaga() {
    yield all([
        ...GlobalSaga
    ]);
}
